import { render, staticRenderFns } from "./PatientReportParams.vue?vue&type=template&id=5418bdd0&scoped=true"
import script from "./PatientReportParams.vue?vue&type=script&lang=js"
export * from "./PatientReportParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418bdd0",
  null
  
)

export default component.exports